module.exports = __webpack_public_path__ + "img/電気回路_3_7_2.f08f95ee.png";